import {RunOutputSamplesTable} from 'lab-automation/output-samples/RunOutputSamplesTableConstants';
import {TableWithoutColumnWidths} from 'notebook/simple-tables/ManagedColumnsSimpleTableEditable';
import {getColumnLabel} from 'notebook/structured-tables/columns/ColumnDefinitions';
import toColumnDefinition from 'notebook/structured-tables/columns/toColumnDefinition';
import {Cell, PLACEHOLDER_CELL} from 'notebook/tables/constants/CellConstants';
import {OVERSIZED_RESULTS_TABLE_TOOLTIP} from 'results/assays/AssayRecordConstants';

export default function outputSamplesTableToTable(outputSamplesTable: RunOutputSamplesTable): {
  table: TableWithoutColumnWidths;
  widths: Array<number>;
} {
  const structuredTableColumns = outputSamplesTable.columns;
  const columnDefinitions = structuredTableColumns.map((structuredTableColumn) =>
    toColumnDefinition({
      structuredTableColumn,
      stageRuns: [],
      canChangeUnits: false, // The table is readonly
      schemas: [],
    })
  );
  const tableRows: Array<Array<Cell>> = outputSamplesTable.rows.length
    ? outputSamplesTable.rows.map((row) => row.cells.map((cell) => ({...cell, locked: true})))
    : [outputSamplesTable.columns.map((column, i) => PLACEHOLDER_CELL)];

  return {
    table: {
      defaultAffixedColumnCount: 1,
      allowAddRows: false,
      allowColumnEdits: false,
      allowNoRows: true,
      allowRowRemoval: false,
      columnConstraints: columnDefinitions.map((columnDefinition, i) => ({
        columnDefinition,
        structuredTableColumn: structuredTableColumns[i],
        editLabelDisabled: true,
      })),
      columnLabels: columnDefinitions.map((columnDefinition) => getColumnLabel(columnDefinition)),
      disallowCustomColumns: true,
      headerRow: false,
      headerCol: false,
      lockedDims: true,
      name: outputSamplesTable.name,
      nameTooltip:
        !outputSamplesTable.rows.length && outputSamplesTable.metadata.numSamples !== 0
          ? OVERSIZED_RESULTS_TABLE_TOOLTIP
          : null,
      rowData: outputSamplesTable.rows.map((row) => {
        const {cells, ...rowData} = row;
        return rowData;
      }),
      table: tableRows,
    },
    widths: structuredTableColumns.map(({width}) => width),
  };
}
